import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// import { postLogData } from './util';
import { canUseSendBeacon, sendBeacon } from './util';
/*
type envHosts = {
  hosts: {
    loggingServiceHost?: string;
    loggingServicePath?: string;
  };
};
const windowEnv = (window.env as unknown) as envHosts;
const { hosts } = windowEnv;
const loggingServiceHost = hosts && (hosts.loggingServiceHost as string);
const loggingServicePath = hosts && (hosts.loggingServicePath as string);
*/

export class LoggerApi {
  constructor(url, headers, enableSendBeacon = true) {
    _defineProperty(this, "url", void 0);

    _defineProperty(this, "isInitialized", false);

    _defineProperty(this, "sendLog", data => {
      if (!this.isInitialized) return;
      const jsonData = JSON.parse(JSON.stringify(data));
      sendBeacon({
        win: window,
        url: this.url.toString(),
        data: jsonData,
        useBlob: true
      });
      /*
      postLogData({
        win: window,
        url: this.url.toString(),
        data: jsonData,
        useBlob: true,
      });
      */
    });

    let lHeaders = headers;
    if (!lHeaders) lHeaders = {};
    const loggingServiceHost = url;
    if (!loggingServiceHost) throw new Error('Unable to instantiate logging service - no url was provided.');
    if (!canUseSendBeacon({
      headers: lHeaders,
      enableSendBeacon
    })) throw new Error('Unable to instantiate logging service - unable to use Window beacon feature.');
    this.url = new URL(loggingServiceHost);
    this.isInitialized = true;
  }

}